import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosi } from '../../config/axios'

const initialState = {
  testers: [],
  status: 'idle',
  error: null,
  totalResults: 0
}

export const fetchTestersAsync = createAsyncThunk(
  'testers/fetchTestersAsync',
  async (params) => {
    const page = params?.page || 1
    const limit = params?.limit || 10
    const res = await axiosi.get(`/testers?page=${page}&limit=${limit}`)
    return res.data
  }
)

export const fetchTesterByIdAsync = createAsyncThunk(
  'testers/fetchTesterByIdAsync',
  async (id) => {
    const res = await axiosi.get(`/testers/${id}`)
    return res.data
  }
)

const testerSlice = createSlice({
  name: 'testerSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestersAsync.pending, (state) => {
        state.status = 'pending'
      })
      .addCase(fetchTestersAsync.fulfilled, (state, action) => {
        state.status = 'fulfilled'
        state.testers = action.payload
        state.totalResults = state.testers.length
      })
      .addCase(fetchTestersAsync.rejected, (state, action) => {
        state.status = 'rejected'
        state.error = action.error
      })
      .addCase(fetchTesterByIdAsync.pending, (state) => {
        state.status = 'pending'
      })
      .addCase(fetchTesterByIdAsync.fulfilled, (state, action) => {
        state.status = 'fulfilled'
      })
      .addCase(fetchTesterByIdAsync.rejected, (state, action) => {
        state.status = 'rejected'
        state.error = action.error
      })
  }
})

export const selectTesters = (state) => state.testerSlice.testers
export const selectTesterStatus = (state) => state.testerSlice.status
export const selectTesterError = (state) => state.testerSlice.error

export default testerSlice.reducer
